import styled from "styled-components";
import { Card, CardBody, FormInput } from "shards-react";

export const CustomizedCard = styled(Card)``;

export const CustomizedCardBody = styled(CardBody)`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const Input = styled(FormInput)`
    margin-bottom: 16px;
`;

export const FormGroup = styled.div`
    width: 100%;
    max-width: 520px;
    display: flex;
    flex-direction: column;
`;
export const Label = styled.label`
    font-size: 14px;
    font-weight: 600;
`;
